module.exports = __webpack_public_path__ + "8d8360b0.png";